<template>
    <v-card outlined class="mx-auto my-4">
      <v-card-title>
        Other URLs ({{ urlFilters.displayedUrls.value.length }})
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <!-- Use the common URL filter chips including sitemap filters -->
            <UrlFilterChips
              :fetch-status-counts="urlFilters.fetchStatusCounts.value"
              :active-fetch-status-filters="urlFilters.activeFetchStatusFilters.value"
              :toggle-fetch-status-filter="urlFilters.toggleFetchStatusFilter"
              show-sitemap-filters
              :sitemap-count="urlFilters.sitemapCount.value"
              :non-sitemap-count="urlFilters.nonSitemapCount.value"
              :active-sitemap-filters="urlFilters.activeSitemapFilters.value"
              :toggle-sitemap-filter="urlFilters.toggleSitemapFilter"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            v-for="url in urlFilters.displayedUrls.value"
            :key="url.pathname"
            cols="12"
            sm="6"
            md="4"
          >
            <UrlCard :item="url" />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </template>
  
  <script setup lang="ts">
  import UrlCard from './UrlCard.vue';
  import UrlTypes from '@/enums/UrlTypes';
  import UrlFilterChips from '@/components/UrlFilterChips.vue';
  import { useUrlFilters } from '@/composables/useUrlFilters';
  
  // Use our new composable for URL filtering. In this case we filter for URLs classified as OTHER.
  const urlFilters = useUrlFilters((url) => url.urlType === UrlTypes.OTHER);
  </script>
  